import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { queryClient, trpc } from "../../../app/trpc.js";
import { Notice } from "../../../ui/index.js";
import { useCabinet } from "../../cabinet/index.js";
import { ShareLinks } from "../ShareLinks.js";
import { StepNav } from "../StepNav.js";
import type { StepProps } from "../types.js";

/** Шаг 8: итог. Ссылка страницы записи и QR, уведомление о данных, «добавить на главный экран»; завершение настройки. */
export function DoneStep({ salonId, state, setState, back }: StepProps) {
  const { t } = useTranslation();
  const cab = useCabinet();
  const navigate = useNavigate();
  const complete = useMutation(
    trpc.onboarding.complete.mutationOptions({
      onSuccess: (s) => {
        setState(s);
        void queryClient.invalidateQueries(trpc.onboarding.status.queryFilter({ salonId }));
        navigate(`${cab.base}/calendar`);
      },
    }),
  );
  return (
    <div>
      <p className="mb-4 text-slate-600">{state.completedAt ? t("onb.done.again") : t("onb.done.intro")}</p>
      <ShareLinks
        bookingUrl={state.bookingUrl}
        noticeUrl={state.noticeUrl}
        salonName={state.salonName}
        closed={state.bookingClosed}
        billingPath={`${cab.base}/billing`}
      />
      {complete.isError && <Notice kind="error">{t("common.error")}</Notice>}
      <StepNav onBack={back} onNext={() => complete.mutate({ salonId })} nextLabel={t("onb.done.finish")} busy={complete.isPending} />
    </div>
  );
}
